import getLanguageCodeForTenantLanguage from 'utils/getLanguageCodeForTenantLanguage'
import { messages as messagesEn } from './en/messages'
import { messages as messagesDe } from './de-DE/messages'
import { messages as messagesAt } from './de-AT/messages'
import { messages as messagesIt } from './it-IT/messages'
import { messages as messagesFr } from './fr-BE/messages'
import { messages as messagesNl } from './nl-BE/messages'
import type { LanguageCodes } from './loadi18n'

const CATALOGS: Record<LanguageCodes, Record<string, string>> = {
  'en': messagesEn,
  'de-DE': messagesDe,
  'de-AT': messagesAt,
  'it-IT': messagesIt,
  'fr-BE': messagesFr,
  'nl-BE': messagesNl,
}

const getLanguage = (): LanguageCodes => {
  const documentLanguage = document?.documentElement?.lang

  return documentLanguage in CATALOGS
    ? (documentLanguage as LanguageCodes)
    : getLanguageCodeForTenantLanguage()
}

export default getLanguage
